"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPostcode = void 0;
var formatPostcode = function (postcode) {
    var postcodeArray = postcode.replace(/\s/g, "").split("");
    postcodeArray.splice(-3, 0, " ");
    return postcodeArray.join("").toUpperCase();
};
exports.formatPostcode = formatPostcode;
